import { render, staticRenderFns } from "./accountlogin.vue?vue&type=template&id=1af8ba68&scoped=true"
import script from "./accountlogin.vue?vue&type=script&lang=js"
export * from "./accountlogin.vue?vue&type=script&lang=js"
import style0 from "./accountlogin.vue?vue&type=style&index=0&id=1af8ba68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8ba68",
  null
  
)

export default component.exports